import Alpine from 'alpinejs'

Alpine.data('stepper', () => {
  return {
    activeIndex: 0,
    activeClass: 'active',
    steps: [],

    prev () {
      if (this.activeIndex > 0) {
        this.activeIndex--
        this.showStep(this.activeIndex)
      }
    },
    next () {
      if (this.activeIndex < this.steps.length - 1) {
        this.activeIndex++
        this.showStep(this.activeIndex)
      }
    },
    showStep (index) {
      this.steps.forEach(step => step.classList.remove(this.activeClass))
      this.steps[index].classList.add(this.activeClass)
    },
    init () {
      this.$nextTick(() => {
        this.steps = this.$el.querySelectorAll('.step')
      })
    },
  }
})
